// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessagingChatClientes_UnlinkInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/messaging_chat_clientes/unlink
 *
 * Remove a chat-client link.
 * Supports both old format { phone: "..." } and new format { identifier: "...", identifier_type: "..." }.
 */
import { registerContract } from './validate'

export interface MessagingChatClientes_UnlinkInput {
cliente_id: number
identifier?: string
identifier_type?: string
phone?: string
}

registerContract('MessagingChatClientes_UnlinkInput', {
  cliente_id:      { type: 'number',  required: true },
  identifier:      { type: 'string',  required: false },
  identifier_type: { type: 'string',  required: false },
  phone:           { type: 'string',  required: false },
})
